import Vue from 'vue'
import App from './App.vue'

import router from './router';

import Vant from 'vant';
import 'vant/lib/index.less';

Vue.use(Vant);


import moment from 'moment'

Vue.prototype.$moment = moment
Vue.filter('datefmt', function (input, fmtstring) {//当input为时间戳时，需转为Number类型
    // 使用momentjs这个日期格式化类库实现日期的格式化功能
    return moment(input).format(fmtstring);
});

import axios from 'axios';

axios.defaults.baseURL = "/api";

// http request 拦截器
axios.interceptors.request.use(
    config => {
        if (window.localStorage.getItem('token')) {
            config.headers.Authorization = "Bearer " + window.localStorage.getItem('token');
        }
        if (window.localStorage.getItem('organ_id')) {
            config.headers.organid = window.localStorage.getItem('organ_id');
        }
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);

// http response 拦截器
axios.interceptors.response.use(
    response => {
        console.log("ok",response);
        return response;
    },
    error => {
        // console.log("error0000",error);


        // console.log("error1",JSON.stringify(error));
        // if (error.response) {
        //     console.log("error2", error.response);
        //     switch (error.response.status) {
        //         case 401:
        //             // 401 清除token信息并跳转到登录页面
        //             window.localStorage.setItem('token', '');
        //             // router.replace({path: '/login'});
        //             window.location.href = "/login"
        //             return
        //     }
        // }


        if (error.message==="Request failed with status code 401" ) {
            console.log("error2", error);
            // 401 清除token信息并跳转到登录页面
            window.localStorage.setItem('token', '');
            // router.replace({path: '/login'});
            window.location.href = "/login"
            return
        }

        //console : Error: Request failed with status code 402
        return Promise.reject(error.response.msg);
    }
);
Vue.$http = Vue.prototype.$http = axios;
Vue.config.productionTip = false

new Vue({
    router,
    render: h => h(App),
}).$mount('#app')

